<template>
  <section>点击侧边栏查看内容</section>
</template>

<script>
export default {}
</script>

<style scoped></style>
